import { render, staticRenderFns } from "./SettingAllocation.vue?vue&type=template&id=50278b30&scoped=true"
import script from "./SettingAllocation.vue?vue&type=script&lang=js"
export * from "./SettingAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50278b30",
  null
  
)

export default component.exports